<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/PackageMasterTableview"></BacktoPage>
          <Headerlayout
            :headertext="
              EditId ? $t('Package.EditMaster') : $t('Package.Master')
            "
            :contenttext="$t('Package.content')"
          >
          </Headerlayout>
        </b-col>
      </b-row>

      <b-form class="form-white-bg my-3" @submit.prevent="IsSubmit">
        <b-row>
          <b-col lg="3" md="3" sm="6" cols="12">
            <div class="field mt-5">
              <TextInput
                type="text"
                placeholder=""
                clearable
                :label="$t('Package.code')"
                name="Code"
                :disabled="true"
                v-model="insert_data.Code"
                :rules="{ required: false, alphanumeric: true }"
                :required-icon="true"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="3" md="3" sm="4" cols="12">
            <!-- <div class="field">
                            <TextInput placeholder="" label="Status" name="status" :required-icon="true"
                                v-model="insert_data.PackageStatus" :rules="{ required: true }" />
                        </div> -->
            <div class="field">
              <CustomDropDown
                :label="$t('Package.status')"
                name="Status"
                :required-icon="true"
                :items="listdataval.Status"
                v-model="insert_data.PackageStatus"
                :rules="{ required: false }"
              />
            </div>
          </b-col>
          <b-col lg="9" md="9" sm="4" cols="12">
            <div class="field float-end">
              <label>{{ $t("Package.packageimages") }}</label>
              <div class="file_upload_field">
                <div class="file_upload_image">
                  <img :src="insert_data.PackageImageUrl" />
                </div>
                <div>
                  <input
                    type="file"
                    class=""
                    name="ServiceImage"
                    id="ServiceImage"
                    @change="handleChangedocument"
                    accept=".jpg, .png, .pdf"
                    style="display: none"
                  />

                  <label
                    for="ServiceImage"
                    class="fileuploadicon mb-0"
                    v-if="insert_data.PackageImageUrl == ''"
                  >
                    <i class="pi pi-plus" id="pkgimgClick"></i>
                  </label>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="3" md="3" sm="4" cols="12">
            <div class="field">
              <CustomDropDown
                :label="$t('Package.packagefor')"
                name="packagefor"
                :required-icon="true"
                :items="listdataval.packageFor"
                v-model="insert_data.PackageType"
                :rules="{ required: true }"
              />
            </div>
          </b-col>
          <b-col lg="3" md="3" sm="4" cols="12">
            <div class="field">
              <!-- <CustomDropDown :label="$t('Package.store')" name="Store" :required-icon="true"
                :items="listdataval.StoreList" v-model="insert_data.StoreId" :rules="{ required: true }"
                :disabled="editdisabled" /> -->
              <StoreDropDown
                :label="$t('Package.store')"
                name="Store"
                :required-icon="true"
                :items="listdataval.StoreList"
                v-model="ModelStoreId"
                :rules="{ required: true }"
                @update:model-value="SelectStore(ModelStoreId)"
                :disabled="editdisabled"
              />
            </div>
          </b-col>
        </b-row>

        <!-- <b-row>
                    <b-col lg="4" md="4" sm="6" cols="12" class="field">
                        <label class="mb-3">Package For</label>
                        <div class="field d-flex align-items-center">
                            <div class="d-flex align-items-center">
                                <RadioButton inputId="homecare" name="homecare" value="homecare" />
                                <label for="homecare" class="ms-2 mb-0">Home Care</label>
                            </div>
                            <div class="d-flex align-items-center">
                                <RadioButton inputId="hospitalcare" name="hospitalcare" value="hospitalcare" />
                                <label for="hospitalcare" class="ms-2 mb-0">Hospital Care</label>
                            </div>
                        </div>
                    </b-col>
                </b-row> -->
        <b-row>
          <b-col lg="4" md="4" sm="6" cols="12">
            <div class="field">
              <TextInput
                placeholder=""
                :label="$t('Package.packagename')"
                name="Package Name"
                :required-icon="true"
                v-model="insert_data.PackageName"
                :rules="{ required: true }"
              />
            </div>
          </b-col>
          <b-col lg="4" md="4" sm="6" cols="12">
            <div class="field">
              <TextInput
                placeholder=""
                :label="$t('Package.displayname')"
                name="Display Name"
                :required-icon="true"
                v-model="insert_data.DisplayName"
                :rules="{ required: false }"
              />
            </div>
          </b-col>
          <b-col lg="8" md="8" sm="8" cols="12">
            <div class="field">
              <TextArea
                placeholder=""
                :label="$t('Package.description')"
                name="Description Name"
                :required-icon="true"
                v-model="insert_data.Description"
                :rules="{ required: false }"
                :rows="4"
              />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <!-- {{ departmentIds }} -->
            <DepartmentComponent v-model="departmentIds" />
          </b-col>
        </b-row>
        <div class="overall-bg">
          <div class="border-bottom">
            <h6 class="compo-heading mb-3 ps-0">
              {{ $t("Package.packagevalidity") }}
            </h6>
            <b-row>
              <b-col lg="3" md="3" sm="4" cols="12">
                <div class="field">
                  <CustomDatePicker
                    :label="$t('Package.activefrom')"
                    name="activefrom"
                    :required-icon="true"
                    id="hj"
                    :rules="{ required: false }"
                    v-model="insert_data.ValidityFromDate"
                    :disabled="chkDisabled.datepicker"
                  />
                </div>
              </b-col>
              <b-col lg="3" md="3" sm="4" cols="12">
                <div class="field">
                  <CustomDatePicker
                    :label="$t('Package.activeto')"
                    name="activeto"
                    :required-icon="true"
                    id="haj"
                    :rules="{ required: false }"
                    v-model="insert_data.ValidityToDate"
                    :disabled="chkDisabled.datepicker"
                  />
                </div>
              </b-col>
              <b-col>
                <div class="field mt-4">
                  <div class="d-flex align-items-center">
                    <Checkbox
                      inputId="alwaysvalid"
                      name="alwaysvalid"
                      :value="1"
                      v-model="insert_data.Isvalid"
                      :binary="true"
                      @change="AlwaysValidChng"
                    />
                    <label for="alwaysvalid" class="ms-2 mb-0">
                      {{ $t("Package.alwaysvalid") }}
                    </label>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="border-bottom mt-3">
            <h6 class="compo-heading mb-3 ps-0">
              {{ $t("Package.packagevalidityforpatient") }}
            </h6>
            <b-row>
              <b-col lg="3" md="3" sm="4" cols="12">
                <div class="field">
                  <TextInput
                    placeholder=""
                    :label="$t('Package.validity(noofdays)')"
                    name="Package Validity"
                    v-model="insert_data.ValidityPeriodDays"
                    :required-icon="true"
                    :rules="{ required: true }"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="border-bottom mt-3">
            <h6 class="compo-heading mb-3 ps-0">
              {{ $t("Package.activatefromnow") }}
            </h6>
            <b-row>
              <b-col lg="3" md="3" sm="4" cols="12">
                <div class="field">
                  <CustomDropDown
                    :label="$t('Package.baseamountype')"
                    name="baseamounttype"
                    :required-icon="true"
                    :items="listdataval.baseAmountType"
                    :rules="{ required: true }"
                    v-model="insert_data.BaseAmountType"
                    @update:modelValue="ChangeBaseAmount"
                  />
                </div>
              </b-col>
              <b-col lg="3" md="3" sm="4" cols="12" v-if="RangeDis">
                <div class="field">
                  <TextInput
                    placeholder=""
                    :label="$t('Package.rangemin')"
                    name="Range Min"
                    :required-icon="true"
                    v-model="insert_data.RangeMin"
                    :rules="{ required: RangeDis, numeric: true }"
                    @change="RangeChange(1)"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="3" md="3" sm="4" cols="12" v-if="RangeDis">
                <div class="field">
                  <TextInput
                    placeholder=""
                    :label="$t('Package.rangemax')"
                    name="Range Max"
                    :required-icon="true"
                    v-model="insert_data.RangeMax"
                    :rules="{ required: RangeDis, numeric: true }"
                    @change="RangeChange(2)"
                  />
                </div>
              </b-col>
              <b-col lg="2" md="2" sm="3" cols="10">
                <div class="field">
                  <TextInput
                    placeholder=""
                    :label="$t('Package.baseamount')"
                    name="Base Amount"
                    :required-icon="true"
                    v-model="insert_data.BaseAmount"
                    :rules="{ required: true, numeric: true }"
                    @change="RangeChange(3)"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="3" md="3" sm="4" cols="12">
                <div class="field">
                  <CustomDropDown
                    :label="$t('Package.discounttype')"
                    name="Discount Type"
                    :required-icon="false"
                    :items="listdataval.discountType"
                    v-model="insert_data.DiscountType"
                    :rules="{ required: false }"
                  />
                </div>
              </b-col>
              <b-col lg="2" md="2" sm="3" cols="10">
                <div class="field">
                  <TextInput
                    placeholder=""
                    :label="$t('Package.discountamount')"
                    name="discountamount"
                    v-model="insert_data.Discount"
                    :required-icon="false"
                    :rules="{ required: false }"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row v-if="chkDisabled.NowChk">
              <b-col>
                <div class="field">
                  <div class="d-flex align-items-center">
                    <Checkbox
                      inputId="activatefromnow"
                      name="activatefromnow"
                      v-model="insert_data.IsActivate"
                      :value="1"
                      :binary="true"
                    />
                    <label for="activatefromnow" class="ms-2 mb-0">
                      {{ $t("Package.activatefromnow") }}
                    </label>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="field">
                  <div class="d-flex align-items-center">
                    <Checkbox
                      inputId="activatefromnow"
                      name="activatefromnow"
                      :value="1"
                      v-model="insert_data.IsConsumable"
                      :binary="true"
                    />
                    <label for="activatefromnow" class="ms-2 mb-0">
                      {{ $t("Package.consumables") }}
                    </label>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <h6 class="compo-heading my-4 ps-0">
            {{ $t("Package.highlights") }}
          </h6>
          <b-row>
            <b-col lg="4" md="4" sm="4" cols="12">
              <div class="field">
                <TextInput
                  placeholder=""
                  :label="$t('Package.highlights')"
                  name="highlights"
                  :required-icon="false"
                  v-model="insert_data.Highlights"
                  :rules="{ required: false }"
                />
              </div>
            </b-col>
            <b-col lg="4" md="4" sm="4" cols="12">
              <div class="field">
                <TextInput
                  placeholder=""
                  :label="$t('Package.salestext')"
                  name="salestext"
                  :required-icon="false"
                  v-model="insert_data.SalesText"
                  :rules="{ required: false }"
                />
              </div>
            </b-col>
            <b-col lg="6" md="6" sm="8" cols="12">
              <div class="field">
                <TextArea
                  placeholder=""
                  :label="$t('Package.descriptions')"
                  name="descriptions"
                  :required-icon="false"
                  v-model="insert_data.HighlightsDescription"
                  :rules="{ required: false }"
                  :rows="4"
                />
              </div>
            </b-col>

            <b-col lg="6" md="6" sm="8" cols="12">
              <div class="field">
                <TextArea
                  placeholder=""
                  :label="$t('Package.terms&conditions')"
                  name="termsandconditions"
                  v-model="insert_data.TermsAndCondition"
                  :required-icon="false"
                  :rules="{ required: false }"
                  :rows="4"
                />
              </div>
            </b-col>
          </b-row>

          <div class="mt-3">
            <!-- {{ listdataval }} -->
            <!-- {{ listdataval.serviceDetailsList }} -->
            <!-- {{ listdataval.serviceDeletList }} -->
            <ServiceDetails
              @serviceList="serviceListdata"
              @serviceDeleteList="serviceDeletedata"
              :StoreId="insert_data.StoreId"
              :serviceDetailsList="listdataval.serviceDetailsList"
            />
          </div>
          <!-- <div>
                        <div class="card_header">
                            <div class="header-content">
                                <h6>Package Highlight</h6>
                            </div>
                            <label class="toggle-switch">
                                <input type="checkbox" class="toggle-input" v-model="OpenPackageHighlight">
                                <span class="toggle-slider"></span>
                            </label>
                        </div>
                        <div v-show="OpenPackageHighlight" class="card_content">
                            
                        </div>
                    </div> -->
          <!-- <div>
                        <div class="card_header mt-3">
                            <div class="header-content">
                                <h6>Consumables</h6>
                            </div>
                            <label class="toggle-switch">
                                <input type="checkbox" class="toggle-input" v-model="OpenConsumables">
                                <span class="toggle-slider"></span>
                            </label>
                        </div>
                        <div v-show="OpenConsumables" class="card_content">
                            <Consumables />
                        </div>
                    </div> -->
        </div>
        <b-row>
          <b-col class="mt-3">
            <Footer :label="label" :loading="Saveloading" />
          </b-col>
        </b-row>
      </b-form>
    </b-container>
  </div>
  <Toast />
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>
<script lang="ts">
import { defineComponent, ref, h, computed, onMounted, watch } from "vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";
import DepartmentComponent from "../../../../../modules/Inventory/components/MasterCreation/DepartmentSubDepartment.vue";
import ServiceDetails from "../../../../../modules/Inventory/components/MasterCreation/ServiceDetails.vue";
import TextInput from "../../../../../components/FormComponents/TextInput.vue";
import TextArea from "../../../../../components/FormComponents/TextArea.vue";
import CustomDatePicker from "../../../../../components/FormComponents/DatePicker.vue";
import CustomDropDown from "../../../../../components/FormComponents/Dropdown.vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import common from "../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import PackageMAsterservice from "../../../Service/PackageMasterService";
import PackageItemMappingMAPservices from "../../../Service/PackageItemMappingService";
import CreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../components/FormComponents/AlreadyExist.vue";
import commonservice from "../../../Service/StoreService";
import Genralservices from "../../../Service/CommonService";
import { useToast } from "primevue/usetoast";
import Loader from "../../../../../components/FormComponents/Loader.vue";

import moment from "moment";
import StoreDropDown from "../../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";

import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,
    DepartmentComponent,
    TextInput,
    CustomDropDown,
    TextArea,
    CustomDatePicker,
    ServiceDetails,
    Footer,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
    StoreDropDown,
  },
  setup(props, { emit }) {
    const date = ref({
      activefrom: ref(),
    });
    const OpenPackageHighlight = ref(false);
    const OpenConsumables = ref(false);

    const toast = useToast();
    //
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.HospitalId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let StoreId = Number(0);
    let HospitalCode = ref(session.HospitalCode);

    let OrganizationId = Number(session.OrganizationId);
    // let BranchId = 1
    // //  Number(session.BranchId);
    // let UserId = 1
    // Number(session.UserId);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    const alreadyexistpop = ref(false);
    const txttype = ref("number");
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const route = useRoute();
    const redirectrouter = useRouter();
    const UpdateId = route.query;
    const EditId = route.query.id;
    const OperationId: any = ref(route.query.OperationId);
    const successpop = ref(false);
    const updatepop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    const RangeDis = ref(false);
    const editdisabled = ref(false);
    let Saveloading = ref(false);

    watch(
      () => t("btn.save"),
      (newValue) => {
        label.value = newValue;
      }
    );

    let insert_data = ref({
      CreatedOn: "2023-11-29T08:00:15.840Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      ModifiedAt: "",
      HospitalId: OrganizationId,
      BranchId: BranchId,
      Id: 0,
      Code: "",
      PackageId: "0",
      PackageValidityDate: "",
      Price: 0,
      Discount: ref(""),
      PackageStatus: ref("1"),
      PackageName: "",
      ValidityPeriodDays: "",
      BaseAmount: "",
      PackageImageUrl: "",
      DiscountType: ref(),
      PackageType: ref(),
      PackageCategory: HospitalCode,
      NeverExpiry: 0,
      ValidityPeriodDate: "",
      MasterCategoryId: 0,
      MasterSubCategoryId: 0,
      MasterDepartmentId: 0,
      SubDepartmentId: 0,
      DisplayOnMobile: 0,
      Remarks: "",
      ValidityFromDate: "",
      ValidityToDate: "",
      Highlights: "",
      IsSurgical: 0,
      IsActivate: ref(),
      PkgShortName: "",
      BaseAmountType: ref(),
      RangeMin: "",
      RangeMax: "",
      EntityId: 0,
      EntityOperationId: 0,
      StoreId: ref(),
      Service_id: 0,
      DisplayName: "",
      Description: "",
      Isvalid: ref(),
      IsConsumable: ref(),
      SalesText: "",
      HighlightsDescription: "",
      TermsAndCondition: "",
      StoreBranchMapId: 0,
    });
    let chkDisabled = ref({
      datepicker: false,
      NowChk: false,
    });

    let listdataval: any = ref({
      department: ref([]),
      subDepartment: ref([]),
      category: ref([]),
      subCategory: ref([]),
      packageFor: ref([
        {
          value: 1,
          name: "home care",
        },
        {
          value: 2,
          name: "hospital care",
        },
      ]),
      Status: ref([
        {
          value: "1",
          name: "Active",
        },
        {
          value: "2",
          name: "InActive",
        },
      ]),
      discountType: ref([
        {
          value: 1,
          name: "Percentage",
        },
        {
          value: 2,
          name: "Flat",
        },
      ]),
      baseAmountType: ref([
        {
          value: 1,
          name: "input",
        },
        {
          value: 2,
          name: "Fixed",
        },
        {
          value: 3,
          name: "Range",
        },
      ]),
      serviceDetailsList: ref([]),
      serviceDeletList: ref([]),
      StoreList: ref([]),
    });

    let departmentIds = ref({
      MasterCategoryId: ref(),
      MasterSubCategoryId: ref(),
      MasterDepartmentId: ref(),
      SubDepartmentId: ref(),
    });
    function serviceListdata(data) {
      listdataval.value.serviceDetailsList = data;
    }
    function serviceDeletedata(data) {
      listdataval.value.serviceDeletList = data;
    }

    function departmentdata(data) {
      departmentIds.value = data.value;
    }

    onMounted(async () => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
      init();
      LoadStore();
    });

    async function init() {
      debugger;
      console.log(UpdateId.id);
      if (UpdateId.id != undefined) {
        try {
          label.value = t("btn.update");
          const EditID = UpdateId.id;
          console.log(EditID);
          try {
            const data_response = await PackageMAsterservice.Edit(EditID);
            const datamap_response = await PackageItemMappingMAPservices.Edit(
              EditID
            );
            listdataval.value.serviceDetailsList = datamap_response["result"];
            const data1 = data_response["result"];
            console.log(data_response["result"]);
            Object.keys(insert_data.value).forEach((key) => {
              if (data1[key]) insert_data.value[key] = data1[key];
            });
            debugger;
            ModelStoreId.value = data1.StoreId;
            insert_data.value.IsConsumable == 1
              ? (insert_data.value.IsConsumable = true)
              : (insert_data.value.IsConsumable = false);
            //insert_data.value.IsActivate == 1 ? insert_data.value.IsActivate = true : insert_data.value.IsActivate = false
            insert_data.value.Isvalid == 1
              ? (insert_data.value.Isvalid = true)
              : (insert_data.value.Isvalid = false);
            Object.keys(departmentIds.value).forEach((key) => {
              if (data1[key]) departmentIds.value[key] = data1[key];
            });

            // departmentIdss.value.MasterCategoryId = data_response["result"].MasterCategoryId
            editdisabled.value = true;
            ChangeBaseAmount(insert_data.value.BaseAmountType);
            AlwaysValidChng();
          } catch (error) {
            alert(error);
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        GetCode();
      }
    }

    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
        redirectrouter.push({
          path: "/ItemMasterTableview",
        });
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      redirectrouter.push({
        path: "/PackageMasterTableview",
      });
      emit("load");
      IsClear();
    }

    // //Clear Input Fields
    const copyinsert_data = JSON.parse(JSON.stringify(insert_data.value));

    function IsClear() {
      Object.assign(insert_data.value, copyinsert_data);

      GetCode();
    }

    //Load HSN
    const HSNDropdown = ref({
      HSNid: null,
      HSNoption: [],
    });

    //Save and Update
    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      Saveloading.value = true;
      if (listdataval.value.serviceDetailsList.length == 0) {
        toast.add({
          severity: "warn",
          summary: "Add the Items",
          detail: "",
          life: 3000,
        });
        return false;
      }

      insert_data.value.CreatedOn = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      insert_data.value.ModifiedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      insert_data.value.ValidityFromDate = insert_data.value.Isvalid
        ? moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")
        : moment(insert_data.value.ValidityFromDate, "DD-MM-YYYY").format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
      insert_data.value.ValidityToDate = insert_data.value.Isvalid
        ? moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")
        : moment(insert_data.value.ValidityToDate, "DD-MM-YYYY").format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
      insert_data.value.PackageValidityDate = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );

      insert_data.value.IsConsumable == true
        ? (insert_data.value.IsConsumable = 1)
        : (insert_data.value.IsConsumable = 0);
      insert_data.value.IsActivate == true
        ? (insert_data.value.IsActivate = 1)
        : (insert_data.value.IsActivate = 0);
      insert_data.value.Isvalid == true
        ? (insert_data.value.Isvalid = 1)
        : (insert_data.value.Isvalid = 0);
      insert_data.value.RangeMin = insert_data.value.RangeMin
        ? insert_data.value.RangeMin
        : "0";
      insert_data.value.RangeMax = insert_data.value.RangeMax
        ? insert_data.value.RangeMax
        : "0";
      insert_data.value.DiscountType == null
        ? 0
        : insert_data.value.DiscountType;

      let objinsert = Object.assign(insert_data.value, departmentIds.value);

      insert_data.value.BranchId = BranchId;

      insert_data.value.EntityId = Number(Entitydata.value.EntityId);
      // insert_data.value.EntityOperationId = Number(OperationId.value);

      try {
        let data_response: any;
        let msg = "";
        const updateid = UpdateId.id;
        if (updateid == undefined) {
          const data_response = await PackageMAsterservice.insert(objinsert);
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;

          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            listdataval.value.serviceDetailsList.forEach((item) => {
              item.PackageId = data_response["result"].Id;
            });
            const PackageItemResult = listdataval.value.serviceDetailsList.map(
              ({ RowNumber, ...rest }) => rest
            );

            // alert(JSON.stringify(PackageItemResult))
            const data_subresponse = await PackageItemMappingMAPservices.insert(
              PackageItemResult
            );

            Saveloading.value = false;
            objinsert.Id = data_response["result"].Id;

            // data_response["result"]
            objinsert.HospitalId = HospitalId;
            const data_responseHSM = await PackageMAsterservice.insertHMS(
              objinsert
            );

            IsClear();
            successpop.value = true;
          }
        } else if (updateid != undefined) {
          const data_response = await PackageMAsterservice.Update(objinsert);
          objinsert.HospitalId = HospitalId;

          const data_hmsresponse = await PackageMAsterservice.UpdateHMS(
            objinsert
          );

          listdataval.value.serviceDetailsList.forEach((item) => {
            item.PackageId = objinsert.Id;
          });
          if (listdataval.value.serviceDeletList.length != 0) {
            for (
              let index = 0;
              index < listdataval.value.serviceDeletList.length;
              index++
            ) {
              const data_response = await PackageItemMappingMAPservices.Delete(
                listdataval.value.serviceDeletList[index]["Id"]
              );
            }
          }

          for (
            let index = 0;
            index < listdataval.value.serviceDetailsList.length;
            index++
          ) {
            if (listdataval.value.serviceDetailsList[index]["Id"] == 0) {
              let mapdata: any = ref([]);
              mapdata.value.push(listdataval.value.serviceDetailsList[index]);
              const data_subresponse =
                await PackageItemMappingMAPservices.insert(mapdata.value);
            }
          }
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            IsClear();
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          console.log(updateid);
        }
      } catch (error) {
        Saveloading.value = false;
        alert(error);
      }
    });

    //Get Auto generate Code
    async function GetCode() {
      debugger;
      try {
        let data = {
          EntityId: Entitydata.value.EntityId,
          HospitalId: OrganizationId,
          BranchId: BranchId,
          StoreId: 0,
        };
        let result: any = await common.getCodeTemplate(data);
        console.log(result);
        insert_data.value.Code = result;
      } catch (error) {}
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      // insert_data.value.Name = "";
      //showDialog.value = true
    }
    async function LoadStore() {
      debugger;
      try {
        const result = await commonservice.getStoreList(HospitalId, BranchId);
        console.log(result);
        listdataval.value.StoreList = result["result"]
          .filter(
            (i1) =>
              i1.IsActive == true &&
              i1.HospitalId == OrganizationId &&
              i1.BranchId == BranchId
          )
          .map((v) => ({
            name: v["Name"],
            value: v["Id"],
          }));
      } catch (error) {}
    }

    const handleChangedocument = async (event: Event) => {
      debugger;
      let result;
      let files: any = "";
      const input = event.target as HTMLInputElement;
      files = input["files"];
      console.log(files);
      // alert('d')

      if (files && files.length > 0) {
        debugger;
        let form = new FormData();
        const file = files[0];
        form.append("FileName", file);
        console.log(form);

        result = await Genralservices.fileupload(form, "");
        console.log("Uploaded :", result);
      }
      let uploadfilename;

      uploadfilename = {
        filename: files[0].name,
        Filepath: result,
      };
      insert_data.value.PackageImageUrl = result;
      // Object.assign(uploadedfilelist.value, uploadfilename);
      // uploadedTableList.value.push(uploadedfilelist.value)
      // console.log(uploadedTableList.value)
      // documents.value.documentname = 0
    };
    //BaseAmount Type Change Function -Tharuni
    function ChangeBaseAmount(value) {
      debugger;
      RangeDis.value = value == 3 ? true : false;
      chkDisabled.value.NowChk = value == 2 ? true : false;
    }
    //Always Valid Change Function-Tharuni
    function AlwaysValidChng() {
      debugger;
      chkDisabled.value.datepicker = insert_data.value.Isvalid ? true : false;
      if (chkDisabled.value.datepicker == true) {
        insert_data.value.ValidityFromDate = "";
        insert_data.value.ValidityToDate = "";
      }
    }
    //Range Change Function -Tharuni
    function RangeChange(val) {
      debugger;
      if (insert_data.value.BaseAmountType == 3) {
        if (val == 1) {
          insert_data.value.RangeMax = "";
          insert_data.value.BaseAmount = "";
        } else if (val == 2) {
          if (
            parseFloat(insert_data.value.RangeMin) >
            parseFloat(insert_data.value.RangeMax)
          ) {
            toast.add({
              severity: "warn",
              summary: "Amount Should greater than Range Min",
              detail: "",
              life: 3000,
            });
            insert_data.value.RangeMax = "";
          }
          insert_data.value.BaseAmount = "";
        } else {
          if (
            parseFloat(insert_data.value.RangeMin) >
            parseFloat(insert_data.value.BaseAmount)
          ) {
            toast.add({
              severity: "warn",
              summary: "Amount Should greater than Range Min",
              detail: "",
              life: 3000,
            });
            insert_data.value.BaseAmount = "";
          } else if (
            parseFloat(insert_data.value.RangeMax) <
            parseFloat(insert_data.value.BaseAmount)
          ) {
            toast.add({
              severity: "warn",
              summary: "Amount exceeds Range Max",
              detail: "",
              life: 3000,
            });
            insert_data.value.BaseAmount = "";
          }
        }
      }
    }
    let ModelStoreId: any = ref();
    function SelectStore(value) {
      debugger;
      if (value) {
        insert_data.value.StoreId = value.Id;
        insert_data.value.StoreBranchMapId = value.StoreBranchMapId;
      }
    }
    return {
      Saveloading,
      handleChangedocument,
      label,
      successpop,
      updatepop,
      closetrigger,
      alreadyclosetrigger,
      alreadyexistpop,
      departmentdata,
      insert_data,
      serviceListdata,
      serviceDeletedata,
      listdataval,
      IsSubmit,
      date,
      OpenPackageHighlight,
      OpenConsumables,
      departmentIds,
      ChangeBaseAmount,
      RangeDis,
      AlwaysValidChng,
      chkDisabled,
      RangeChange,
      editdisabled,
      EditId,
      ModelStoreId,
      SelectStore,
    };
  },
});
</script>

<style>
/*FileUploadField*/
.fileuploadicon .pi {
  background-color: #f7f7f7;
  border: 1px solid #e1e1e1;
  color: #0148e2;
  padding: 9px 15px;
}

.file_upload_image {
  border: 1px solid #e1e1e1;
  background-color: #f7f7f7;
  width: 50px;
  height: 35px;
  margin: 0px 3px;
}

.file_upload_field {
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  margin-top: 5px;
}

/*FileUploadField*/

.header-content {
  display: flex;
  align-items: center;
}

.card_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  padding: 15px;
}

.card_content {
  background: #f9fbfc;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.toggle-input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e9e1e1;
  border-radius: 34px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: #28c840;
  border-radius: 50%;
  transition: transform 0.3s ease-in-out;
}

.toggle-input:checked + .toggle-slider {
  background-color: #e9e1e1;
}

.toggle-input:checked + .toggle-slider:before {
  transform: translateX(26px);
}
</style>
